import Service from '../../../service/api.js';
import router from '../../../router/index.js';
import store from '../../store';
const LoginModule = {
  namespaced: true,
  state: {
    userData: {
      _id: '',
      education: [],
      userinfo: {},
      username: '',
      userType: '',
      codeId: '',
    },
    authMessage: {
      th: '',
      en: '',
      type: '',
      status: false,
    },
    isSignin: false,
    openModalVerifyOTP: false,
    openModalEmail: false,
    newSecret: '',
    loading: false,
    notify: [],
  },

  mutations: {
    onSetEducation(state, value) {
      console.log('onSetEducation', value);
      state.userData.education = value;
    },
    closeAlertStatus(state) {
      state.authMessage.en = '';
    },
    setUserData(state, userData) {
      state.userData = userData;
      state.isSignin = true;
    },
    setAuthMessage(state, message) {
      state.authMessage = message;
    },
    logout(state) {
      state.isSignin = false;
    },
    setOpenModalEmail() {
      state.openModalEmail = true;
    },
    setOpenModalVerifyOTP(state) {
      state.openModalVerifyOTP = true;
    },
    setCloseModalVerifyOTP(state) {
      state.openModalVerifyOTP = false;
    },
    setCloseModalEmail() {
      state.openModalEmail = false;
    },
    closeModalLogin(state) {
      state.authMessage.status = false;
    },
    setStatusModal(state) {
      state.authMessage.status = !state.authMessage.status;
    },
    setNewSecret(state, value) {
      state.newSecret = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setNotify(state, value) {
      state.notify = value;
    },
  },
  actions: {
    fetchCourseEducation({commit}) {
      // fetch after user login so need to has if statement
      Service.onGetProfile()
        .then((res) => {
          console.log('fetchCourseEducation', res.data.data.userCourse);
          commit('onSetEducation', res.data.data.userCourse);
        })
        .catch((err) => {});
    },
    fetchUpdateUserData({commit}, body) {
      let payload = {
        _id: body.data.userProfile._id,
        education: body.data.userProfile.userinfo.education,
        userinfo: body.data.userProfile.userinfo.userinfo,
        username: body.data.username,
        userType: body.data.userProfile.userType,
      };
      commit('setUserData', payload);
    },
    onLogin({commit}, body) {
      commit('setLoading', true);
      Service.onLogin(body)
        .then((response) => {
          localStorage.setItem('token', response.data.data.x_access_token);
          let body = {
            _id: response.data.data._id,
            education: response.data.data.userinfo.education,
            userinfo: response.data.data.userinfo.userinfo,
            username: response.data.data.username,
            userType: response.data.data.userType,
            codeId: response.data.data.codeId,
          };
          commit('setUserData', body);
          commit('setNotify', response.data.data.notifys);
          let message = {
            th: response.data.description,
            en: '',
            type: 'success',
            status: false,
          };
          commit('setAuthMessage', message);
          store.dispatch('profile/getUserProfile');
          store.dispatch('auth/fetchCourseEducation');
          commit('setLoading', false);
          store.commit('necessary/setLessonActive', 0);
        })
        .catch((err) => {
          let message = {
            th: err.response.data.description,
            en: err.response.data.descriptionEn,
            type: 'danger',
            status: true,
          };
          commit('setAuthMessage', message);
          //alert(err.response.data.code)
          if (err.response.data.code == 40107) {
            // Resend OTP
            Service.onSendOTP({username: body.username}).then((res) => {
              commit('setNewSecret', res.data.secret);
              commit('setLoading', false);
            });
          } else {
            commit('setLoading', false);
          }
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },
    loginGoogle({commit}, authData) {
      commit('setLoading', true);
      Service.onGoogleLogin(authData)
        .then((response) => {
          localStorage.setItem('token', response.data.data.x_access_token);
          let body = {
            _id: response.data.data._id,
            education: response.data.data.userinfo.education,
            userinfo: response.data.data.userinfo.userinfo,
            username: response.data.data.username,
            userType: response.data.data.userType,
            codeId: response.data.data.codeId,
          };
          commit('setUserData', body);
          commit('setNotify', response.data.data.notifys);
          let message = {
            th: response.data.description,
            en: '',
            type: 'success',
            status: false,
          };
          commit('setAuthMessage', message);
          store.dispatch('profile/getUserProfile');
          store.dispatch('auth/fetchCourseEducation');
          commit('setLoading', false);
        })
        .catch((err) => {
          if (err.response.data.code == 40402) {
            Service.onGoogleLoginSecondPath(authData)
              .then((response) => {
                localStorage.setItem(
                  'token',
                  response.data.data.x_access_token
                );
                let body = {
                  _id: response.data.data._id,
                  education: response.data.data.userinfo.education,
                  userinfo: response.data.data.userinfo.userinfo,
                  username: response.data.data.username,
                  userType: response.data.data.userType,
                  codeId: response.data.data.codeId,
                };
                commit('setUserData', body);
                commit('setNotify', response.data.data.notifys);
                let message = {
                  th: response.data.description,
                  en: '',
                  type: 'success',
                  status: false,
                };
                commit('setAuthMessage', message);
                store.dispatch('profile/getUserProfile');
                store.dispatch('auth/fetchCourseEducation');
                commit('setLoading', false);
              })
              .catch((err) => {
                commit('setLoading', false);
              });
          }
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },
    facebookLogin({commit}, authData) {
      commit('setLoading', true);
      Service.onFacebookLogin(authData)
        .then((response) => {
          localStorage.setItem('token', response.data.data.x_access_token);
          let body = {
            _id: response.data.data._id,
            education: response.data.data.userinfo.education,
            userinfo: response.data.data.userinfo.userinfo,
            username: response.data.data.username,
            userType: response.data.data.userType,
            codeId: response.data.data.codeId,
          };
          commit('setUserData', body);
          commit('setNotify', response.data.data.notifys);
          let message = {
            th: response.data.description,
            en: '',
            type: 'success',
            status: false,
          };
          commit('setAuthMessage', message);
          store.dispatch('profile/getUserProfile');
          store.dispatch('auth/fetchCourseEducation');
          commit('setLoading', false);
        })
        .catch((err) => {
          if (err.response.data.code == 40402) {
            Service.onFacebookLoginSecondPath(authData)
              .then((response) => {
                localStorage.setItem(
                  'token',
                  response.data.data.x_access_token
                );
                let body = {
                  _id: response.data.data._id,
                  education: response.data.data.userinfo.education,
                  userinfo: response.data.data.userinfo.userinfo,
                  username: response.data.data.username,
                  userType: response.data.data.userType,
                  codeId: response.data.data.codeId,
                };
                commit('setUserData', body);
                commit('setNotify', response.data.data.notifys);
                let message = {
                  th: response.data.description,
                  en: '',
                  type: 'success',
                  status: false,
                };
                commit('setAuthMessage', message);
                store.dispatch('profile/getUserProfile');
                store.dispatch('auth/fetchCourseEducation');
                commit('setLoading', false);
              })
              .catch((err) => {
                commit('setLoading', false);
              });
          }
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },
    ssoAuthorize() {
      console.log('ssoAuth Login');

      const params = new URLSearchParams({
        response_type: 'code',
        client_id: process.env.VUE_APP_CLIENT_ID,
        redirect_uri: process.env.VUE_APP_REDIRECT_URI,
        resource: process.env.VUE_APP_RESOURCE,
        scope: 'openid profile email',
      });
      window.location.href = `${
        process.env.VUE_APP_ADFS_DOMAIN
      }/oauth2/authorize?${params.toString()}`;
    },
    ssoAuthorizeLogout({commit}, token) {
      console.log('logout get code', token);

      const params = new URLSearchParams({
        id_token_hint: token,
        post_logout_redirect_uri: process.env.VUE_APP_REDIRECT_URI,
      });
      console.log('ssoAuth Logout begin to redirect', params.toString());

      window.location.href = `${
        process.env.VUE_APP_ADFS_DOMAIN
      }/oauth2/logout?${params.toString()}`;
      console.log(
        `${process.env.VUE_APP_ADFS_DOMAIN}/oauth2/logout?${params.toString()}`,
        'go to'
      );
    },

    ssoLogin({commit}, body) {
      // console.log(body, 'ssologin body');
      commit('setLoading', true);

      Service.onSSOLogin(body)
        .then((response) => {
          console.log(response, 'for sso login responses');

          localStorage.setItem('token', response.data.data.x_access_token);
          console.log(response.data.data, 'data one');

          let ssoTokenToStore = response.data.ssoToken;
          if (ssoTokenToStore && typeof ssoTokenToStore === 'object') {
            ssoTokenToStore = ssoTokenToStore.id_token || '';
          }
          localStorage.setItem('ssotoken', ssoTokenToStore);

          let body = {
            _id: response.data.data._id,
            education: response.data.data.userinfo.education,
            userinfo: response.data.data.userinfo.userinfo,
            username: response.data.data.username,
            userType: response.data.data.userType,
            codeId: response.data.data.codeId,
          };
          commit('setUserData', body);
          commit('setNotify', response.data.data.notifys);
          let message = {
            th: response.data.description,
            en: '',
            type: 'success',
            status: false,
          };
          commit('setAuthMessage', message);
          store.dispatch('profile/getUserProfile');
          store.dispatch('auth/fetchCourseEducation');
          commit('setLoading', false);
          store.commit('necessary/setLessonActive', 0);
        })
        .catch((err) => {
          console.log(err, 'err for sso login responses');

          let message = {
            th: err.response.data.description,
            en: err.response.data.descriptionEn,
            type: 'danger',
            status: true,
          };
          commit('setAuthMessage', message);
          //alert(err.response.data.code)
          if (err.response.data.code == 40107) {
            // Resend OTP
            Service.onSendOTP({username: body.username}).then((res) => {
              commit('setNewSecret', res.data.secret);
              commit('setLoading', false);
            });
          } else {
            commit('setLoading', false);
          }
        })
        .finally(() => {
          commit('setLoading', false);
        });
    },
    logout({commit, dispatch}) {
      // FB.api('/me/permissions', 'delete', null, () => FB.logout());
      const getSSO = localStorage.getItem('ssotoken');
      const hadToken = localStorage.getItem('token') !== null;

      //clean state first
      store.commit('profile/clearProfile');
      commit('logout');
      commit('necessary/setCourseOverviewLogOut');

      //clear storage out
      localStorage.clear();

      //check if that sso
      if (getSSO) {
        console.log('redirect to SSO provider....', getSSO);
        dispatch('ssoAuthorizeLogout', getSSO);
      } else {
        //old login flow
        router.push('/homepage');
        if (!hadToken) {
          location.reload();
        }
      }

      ///////// old
      // //for sso clear
      // if (getSSO) {
      //   //commit here
      //   console.log(getSSO, 'getItem');

      //   dispatch('ssoAuthorizeLogout', getSSO);
      //   // localStorage.removeItem('ssotoken');
      // }
      // // localStorage.removeItem('vuex');
      // // localStorage.removeItem('token');
      // localStorage.clear();

      // store.commit('profile/clearProfile');
      // commit('logout');
      // commit('necessary/setCourseOverviewLogOut');

      // if (!getSSO) {
      //   router.push('/homepage');
      //   if (localStorage.getItem('token') !== null) {
      //     //alert("have token")
      //   } else {
      //     //alert("no token")
      //     location.reload();
      //   }
      // }
    },
    dataCourse: function dataCourse(state, res) {
      state.courseCode = res.courseCode;
      state.courseObjectId = res.objectId;
    },
  },

  getters: {
    userInformation(state) {
      return state.userData;
    },
    authMessage(state) {
      return state.authMessage;
    },
    authModal(state) {
      return state.authMessage.status;
    },
    userStatus(state) {
      return state.isSignin;
    },
    newSecret(state) {
      return state.newSecret;
    },
    modalVerifyOTP(state) {
      return state.openModalVerifyOTP;
    },
    userCourses(state) {
      return state.userData.education;
    },
    loading(state) {
      return state.loading;
    },
    getNotify(state) {
      return state.notify;
    },
  },
};

export default LoginModule;
